<template>
  <router-view></router-view>
</template>
<script setup lang="ts">
import { configStore } from '@/stores/config.store';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

const useConfigStore = configStore;
const store = useConfigStore();
const { locale } = useI18n();

watch(
  () => store.globalConfig?.ods?.language,
  (language) => {
    if (language && ['en', 'zh', 'vi'].includes(language)) locale.value = language;
  },
  { immediate: true }
);
</script>
<style lang="scss"></style>
